<template>

  <div>
    <b-card border-variant="info" class="text-center">
      <template v-slot:header>
        <strong>判定結果：<div class="predictDispCls">{{predictResult}}</div>（AI確率：{{predictRate}}%）</strong>
      </template>

      <ChartBar id="outprdict_graph" :chartData="chartDatas" :options="chartOptions" class="barchart"></ChartBar>

      <div><b><font color=red>{{actMessage}}</font></b></div><br>

      <OutAction></OutAction>

    </b-card>
  </div>

</template>

<script>
import { mapState } from 'vuex'
import ChartBar from '@/components/ChartBar.vue'
import OutAction from '@/components/OutAction.vue'
import axios from 'axios' // Ajax通信ライブラリ

export default {
  name: 'outpredict',
  data () {
    return {
      chartDatas: {},
      chartOptions: {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: 'Label [分類]'
              }
            }
          ],
          yAxes: [
            {
              ticks: {
                min: 0,
                max: 1,
                callback: (label, index, labels) => (label * 100).toLocaleString() + '%'
              }
            } // 左の軸。他の設定はデフォルトのまま
          ]
        },
        tooltips: { // ツールチップの設定
          mode: 'index' // 全データを表示する
        }
      },
      predictResult: '-----',
      predictRate: '',
      canvas: null,
      ctx: null,
      maxindex: null,
      actMessage: ''
    }
  },
  components: {
    ChartBar,
    OutAction
  },
  computed: {
    ...mapState([ 'inputs', 'controlKits', 'setActions' ]),
    /* lineLabels () {
      const tmpLabels = []
      for (let key in this.inputs) {
        tmpLabels.push(this.inputs[key].name)
      }
      // console.log(tmpLabels)
      return tmpLabels
    }, */
    consolevue: () => console.error
  },
  methods: {
    // -------------------------------- GRAPH --------------------------------
    updateChartData (updateFlag, predData) {
      // Label更新フラグあり時のみ更新
      if (updateFlag) {
        if (predData.length === 0) {
          this.predictResult = '判定不可(再学習要)'
          return
        }
        // Rate表示
        var tempRate = 0.0
        for (var i = 0; i < predData.length; i++) {
          if (tempRate < predData[i]) {
            tempRate = predData[i]
          }
        }
        this.predictRate = parseInt(tempRate * 100)
        // Label表示
        this.maxindex = predData.indexOf(Math.max(...predData))
        this.predictResult = this.inputs[this.maxindex].name
      }
      const tmpLabels = []
      for (let key in this.inputs) {
        tmpLabels.push(this.inputs[key].name)
      }
      this.chartDatas = {
        // labels: this.lineLabels, // Computedでも同じ結果（updateChartData実行時にラベル更新）
        labels: tmpLabels,
        datasets: [
          {
            label: '確率 [AI確率]',
            data: predData,
            backgroundColor: 'rgba(255, 99, 132, 0.8)',
            borderColor: 'rgba(0, 0, 0, 1)'
          }
        ]
      }
    },
    aryMax (a, b) {
      return Math.max(a, b)
    },
    controlKitRenkei () {
      const actNum = this.inputs[this.maxindex].act
      // 【注意】キャストしないと検索できない
      var actIndex = this.setActions.findIndex(setAction => parseInt(setAction.no) === parseInt(actNum))
      // console.log('actIndex:' + actIndex)
      const aUrl = this.setActions[actIndex].url
      const aName = this.setActions[actIndex].act
      if (actNum === 0) {
        this.actMessage = 'Kit制御は有りません'
        this.$emit('lastPred')
        return
      } else {
        this.actMessage = 'Kit制御:' + aName
      }
      if (aUrl === '') {
        this.actMessage = 'Kit制御内容を選択して下さい。'
        this.$emit('lastPred')
        return
      }
      if (this.controlKits.ipstate === false) {
        this.actMessage = 'Kit制御のIPアドレスを設定して下さい。'
        this.$emit('lastPred')
        return
      }
      // データ取得
      const getUrl = 'http://' + this.controlKits.kitip + aUrl
      console.log('kitUrl:' + getUrl)
      axios.get(getUrl)
        .then(function (response) {
          // handle success(axiosの処理が成功した場合に処理させたいことを記述)
          this.$emit('lastPred')
        }.bind(this)).catch(function (error) {
          // handle error(axiosの処理にエラーが発生した場合に処理させたいことを記述)
          console.log(error)
          this.$store.dispatch('setMessage', 'Kit連携に失敗しました')
          this.$emit('lastPred')
        }.bind(this)).finally(function () {
          // always executed(axiosの処理結果によらずいつも実行させたい処理を記述)
        })
    },
    setMessage (msg) {
      this.$store.dispatch('setMessage', msg)
    }
  },
  mounted () {
    this.updateChartData(false, [])
  }
  // -------------------------------- GRAPH --------------------------------
}
</script>
<style scoped>
div.card-header, div.card-body {
  padding: 0;
}
.barchart {
  width: 477px;
  height: 250px;
  margin: 10px auto;
}
.predictDispCls {
  display: inline-block;
  color:red;
  font-size: 200%;
}
</style>



// WEBPACK FOOTER //
// src/components/OutPredict.vue